import { Component, OnInit } from '@angular/core';
import { DownpaymentService } from './down-payment.service';
import { ApplicationService } from '../application.service';
import { Application } from '../application';
import { HeaderService, Header } from '../../common/header/header.service';
import { FooterService, Footer } from '../../common/footer/footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';
import { AwsTracker, Level, EventDetails } from '../../common/tracking/aws-tracker';
import { environment } from '../../../environments/environment';
import { TokenService } from '../../token/token.service';
import { RiskService } from 'app/risk/risk.service';
declare var $: any;

@Component({
  selector: 'zest-down-payment',
  templateUrl: './down-payment.component.html',
  styleUrls: ['./down-payment.component.scss']
})
export class DownPaymentComponent implements OnInit {

  public application: Application;
  public processingElec = false;
  public processingCOD = false;
  public merchantName = '';
  public errorMsg = '';
  private pageTracker: AwsTracker;
  public payUform: any;
  public payLater = false;
  public payuActionUrl: string = environment.payuActionUrl;
  public DPPageDone = false;
  public isDpAfterRiskApproval = false;

  constructor(private downpaymentService: DownpaymentService,
    private tokenService: TokenService,
    private awsTrackingService: AwsTrackingService,
    private route: ActivatedRoute,
    private router: Router,
    private riskService: RiskService,
    private headerService: HeaderService,
    private footerService: FooterService,
    private loaderService: LoaderService,
    private applicationService: ApplicationService) { }

  ngOnInit() {
    const states = this.applicationService.getPreapproveStates();
    const isRiskDecisionTaken = states.loan.IsRiskAccepted || states.loan.IsRiskDeclined || states.loan.IsRiskRefered;

    this.headerService.ShowHeaderSource.next(new Header(1, true, 50, true, 'Downpayment', false));
    this.footerService.ShowFooterSource.next(new Footer(true, false, true, true, true, true));
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.pageTracker = new AwsTracker(Level.Page, 'DP_Page');
    this.awsTrackingService.gtmPageLoadEvent('DP-Page-Loaded');
    this.isDpAfterRiskApproval = this.applicationService.getDpConfig();

    this.route.queryParams.subscribe(value => {
      if (value.error === 'true') {
        this.errorMsg = 'Transaction failed, please try again here. We have also sent you a link to pay via email and sms.';
      }
    });
    this.application = this.applicationService.getApplication();
    if (this.application && this.applicationService.getCreditLimitCust() && this.isDpAfterRiskApproval && !isRiskDecisionTaken) {
      this.riskService.createRiskTask(this.application.ApplicationId).subscribe(riskEngineResponse => {
        if (riskEngineResponse.decision_code === 4 || ((riskEngineResponse.decision_code === 2 || riskEngineResponse.decision_code === 5) && riskEngineResponse.result === true)) {
          this.initDpPage(); // Risk Approved Txn
        } else {
          this.router.navigate(['/info-page/loan-rejected']); // Risk Declioned Txn
        }
      }, error => this.initDpPage());
    } else {
      this.downpaymentService.getRepaymentsData(this.application.ApplicationId).subscribe(res => {
          if (res.PaymentOption === 'CashOnDelivery') {
            this.applicationService.goToNextRoute('/customer/statements');
          } else {
            this.initDpPage();
          }
      }, error => {
        if (error.status === 404) {
          this.initDpPage();
        }
      });
    }
  }
  initDpPage() {
    this.downpaymentService.getDetails(this.application.ApplicationId).subscribe(response => {
      this.application.IsCODEnabled = response.IsCODEnabled;
      const merchantSettings = this.tokenService.getMerchantSettings();
      const props = this.awsTrackingService.setGlobalCustomProps();
      const event = new EventDetails('DP', 'page', 'load');
      this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
      const selectedMerchantSetting = merchantSettings.filter(merchant => (merchant.merchantId === this.application.MerchantId))[0];
      if ((response.InitialPaymentAmount === 0) || (selectedMerchantSetting && selectedMerchantSetting.isSkipDownpayment)) {
        this.payWithCOD();
      } else {
        this.getPendingTransactions();
      }
    });
    this.merchantName = this.applicationService.getApplication().MerchantName;
    // Pay later for EMI BABA
    if (this.merchantName.toLowerCase().indexOf('emibaba') > -1) {
      this.payLater = true;
    }
  }
  getPendingTransactions() {
    this.downpaymentService.getPendingTransaction(this.application.ApplicationId).subscribe(response => {
      if (response.pendingTxnsAvailable) {
        setTimeout(fn => { $('#showDPPopupModal').modal('open'); }, 0);
      }
      this.getDownPaymentStatus();
    }, error => {
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    });
  }
  payWithElec() {
    this.processingElec = true;
    const event = new EventDetails('PrimaryCTA', 'click', 'triggered');
    const props = {
      Action: 'Proceed',
      View: 'DP'
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
    this.awsTrackingService.sendData(this.pageTracker, this.applicationService.getApplicationId(), this.tokenService.getCustomerId()).subscribe();
    this.awsTrackingService.gtmTriggerEvent('DP-Complete');
    this.router.navigate(['/application/payment']);
  }
  getDownPaymentStatus(count?: number) {
    this.application = this.applicationService.getApplication();
    if (this.application) {
      this.applicationService.getState(this.application.ApplicationId).subscribe(response => {
        if (response.loan.IsDownpaymentComplete) {
          this.application.IsDPMade = true;
          this.applicationService.saveApplication(this.application);
          this.awsTrackingService.gtmTriggerEvent('DP-Complete');
          this.applicationService.goToNextRoute(this.router.url);
        } else {
          if (this.DPPageDone && !count) {
            count = 0;
          }
          if (this.DPPageDone && count < 10) {
            setTimeout(() => { this.getDownPaymentStatus(count + 1); }, (1000 + count * 1000));
          } else {
            this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
            this.application.IsDPMade = false;
            this.applicationService.saveApplication(this.application);
          }
        }
      }, error => {
        this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
        this.application.IsDPMade = false;
        this.applicationService.saveApplication(this.application);
      });
    }
  }
  payWithCOD() {
    this.processingCOD = true;
    this.awsTrackingService.sendData(this.pageTracker, this.applicationService.getApplicationId(), this.tokenService.getCustomerId()).subscribe();
    this.downpaymentService.setCashOnDelivery(this.application.ApplicationId).subscribe(response => {
      this.DPPageDone = true;
      this.getDownPaymentStatus();
    }, error => {
      this.errorMsg = 'Transaction failed. Please try again.';
      this.processingCOD = false;
    });
  }

}
